import makeStyles from '@mui/styles/makeStyles';

const createClasses = makeStyles(theme => ({
  container: {
    maxWidth: '389px'
  },

  heading: {
    maxWidth: '353px',
    marginBottom: theme.spacing(1),

    '& span': {
      color: theme.palette.secondary[500]
    }
  },

  subtitle: {
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(4)
  },

  checkbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    height: '17px',

    '& span': {
      paddingLeft: 0
    }
  }
}));

export default createClasses;
